module.exports = __webpack_public_path__ + "img/platform-B-3.66a526a9.jpg";